
import EoNavLink from '../EoNavLink/EoNavLink.vue'
import EoTransitionAccordion from '../../EoTransitionAccordion/EoTransitionAccordion.vue'

export default {
  name: 'EoNavItem',
  components: { EoNavLink, EoTransitionAccordion },
  props: {
    /**
     * Textual label of the item
     */
    label: {
      type: String,
      default: '',
      required: true,
    },
    /**
     * URL to link to
     */
    url: {
      type: String,
      default: null,
    },
    /**
     * Icon to show before label
     */
    icon: {
      type: String,
      default: null,
    },
    /**
     * Add a submenu of sub items
     */
    children: {
      type: Array,
      default: () => null,
    },
    /**
     * Expand item by default
     */
    expandDefault: {
      type: Boolean,
      default: false,
    },
    /**
     * Style: url to an image to show
     */
    image: {
      type: String,
      default: null,
    },
    /**
     * Style: text size and accompanied styling (md) (lg) (xl)
     */
    size: {
      type: String,
      default: 'md',
      validator: prop => Object.values(['md', 'lg', 'xl']).includes(prop),
    },
    /**
     * Style: color of some hyperlinks and buttons
     */
    accentColor: {
      type: String,
      default: null,
    },
    /**
     * Style: default color of the text and icons
     */
    textColor: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      isExpanded: false,
      dynamicTextColor: 'black',
    }
  },
  computed: {
    isInternalLink () {
      if (this.url && (this.url.startsWith('http://') || this.url.startsWith('https://'))) {
        return false
      }
      return true
    },
    internalLinkTag () {
      if (this.$root.$options.components.NuxtLink) {
        return 'nuxt-link'
      } else if (this.$root.$options.components.RouterLink) {
        return 'router-link'
      } else {
        return 'a'
      }
    },
    classes () {
      return {
        'eo-nav-item': true,
        ['is-size--' + this.size]: !!this.size,
      }
    },
    classesLink () {
      return {
        'eo-nav-item__link': true,
        ['text--' + this.dynamicTextColor]: !!this.dynamicTextColor,
      }
    },
    linkIconAfter () {
      if (this.children) {
        return this.isExpanded ? 'chevron-down' : 'chevron-right'
      } else {
        return !this.isInternalLink ? 'external-link' : null
      }
    },
    linkProps () {
      return {
        label: this.label,
        iconBefore: this.icon,
        iconAfter: this.linkIconAfter,
        size: this.size,
        textColor: this.dynamicTextColor,
      }
    },
  },
  created () {
    this.isExpanded = false // this.expandDefault
    this.dynamicTextColor = this.textColor
  },
  methods: {
    toggleSublist () {
      this.isExpanded = !this.isExpanded
    },
    onHover () {
      if (this.size === 'lg' ) {
        this.dynamicTextColor = this.accentColor
      }
      this.emitHover(this)
    },
    onLeave () {
      if (this.size === 'lg' ) {
        this.dynamicTextColor = this.textColor
      }
      this.emitHover(null)
    },
    onLinkEnter () {
      this.onLinkClick()
      
    },
    onLinkClick () {
      this.emitNavigate(this)
      this.onLeave()
    },
    emitHover (item) {
      this.$emit('hover', item)
    },
    emitNavigate (item) {
      this.$emit('navigate', item)
    },
  },
}
